import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
import _objectDestructuringEmpty from '/app/node_modules/babel-runtime/helpers/objectDestructuringEmpty';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { BadRequestError, WarningError, InternalServerError, UnknownError, UnauthorizedError, GatewayTimeoutError, BadGatewayError } from '../abstractions/errors';
import { isEmpty } from '../mappers/Utils';
import axios from 'axios';
var url = require('url');

export var state = function state() {
	return {
		cancellationTokenSource: null,
		publicUrls: ['/personal-data-protection-law', '/affiliation-terms-and-conditions', '/restore-password'],
		isPublicPage: false
	};
};

export var mutations = {
	setCancellationTokenSource: function setCancellationTokenSource(state, cancellationTokenSource) {
		state.cancellationTokenSource = cancellationTokenSource;
	},
	setIsPublicPage: function setIsPublicPage(state, isPublicPage) {
		state.isPublicPage = isPublicPage;
	}
};

export var actions = {
	nuxtServerInit: function () {
		var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
			var state = _ref.state,
			    dispatch = _ref.dispatch,
			    commit = _ref.commit;
			var req = _ref2.req,
			    redirect = _ref2.redirect;
			var requestUrl, cookieValue;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;
							requestUrl = url.parse(req.url);
							// console.log('nuxtServerInit', requestUrl)

							cookieValue = this.$readAuthCookie();

							if (!cookieValue) {
								_context.next = 9;
								break;
							}

							commit('user/setUserData', cookieValue, { root: true });
							_context.next = 7;
							return dispatch('master-data/initialLoad');

						case 7:
							_context.next = 10;
							break;

						case 9:
							if (state.publicUrls.indexOf(requestUrl.pathname) > -1) {
								commit('setIsPublicPage', true);
								commit('dashboard/details/setToolbarTitle', '', { root: true });
							} else {
								if (requestUrl.pathname === '/load-ad') redirect(requestUrl.path);else redirect('/');
							}

						case 10:
							;
							_context.next = 16;
							break;

						case 13:
							_context.prev = 13;
							_context.t0 = _context['catch'](0);

							console.log(_context.t0);

						case 16:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this, [[0, 13]]);
		}));

		function nuxtServerInit(_x, _x2) {
			return _ref3.apply(this, arguments);
		}

		return nuxtServerInit;
	}(),
	controlMessage: function controlMessage(_ref4, error) {
		_objectDestructuringEmpty(_ref4);

		if (error instanceof BadRequestError) {
			this.$swal('Parametros invalidos', _JSON$stringify(error.data), 'warning');
		} else if (error instanceof UnauthorizedError) {
			console.log('no autorizado!');
		} else if (error instanceof WarningError) {
			var seeError = false;
			var message = '';
			if (isEmpty(error)) {
				if (isEmpty(error.message)) {
					seeError = true;
					message = error.message;
				}
			}
			this.$swal(seeError ? message : 'Ocurrió un error con su solicitud', seeError ? '' : 'Vuelva a reintentar', 'warning');
		} else if (error instanceof InternalServerError) {
			this.$swal('Ocurri\xF3 un error en el servidor: ' + error.message, error.stack || '', 'error');
		} else if (error instanceof BadGatewayError) {
			this.$swal('Error de conexi\xF3n', 'Por el momento no podemos conectarnos a los servicios del sistema (504 Gateway timeout)', 'error');
		} else if (error instanceof GatewayTimeoutError) {
			this.$swal('Error de conexi\xF3n', 'No se recibió una respuesta correcta de los servicios del sistema (502 Bad gateway)', 'error');
		} else if (error instanceof UnknownError) {
			this.$swal('Ocurrió un error con su solicitud', error.data || '', 'error');
		} else {
			this.$swal('Error: ' + error.message, error.stack || '', 'error');
		}
	},
	getCancellationToken: function getCancellationToken(_ref5) {
		var commit = _ref5.commit;

		var source = axios.CancelToken.source();
		commit('setCancellationTokenSource', source);
		return source.token;
	},
	cancelRequest: function cancelRequest(_ref6) {
		var commit = _ref6.commit,
		    state = _ref6.state;

		if (!state.cancellationTokenSource) return;
		state.cancellationTokenSource.cancel();
		commit('setCancellationTokenSource', null);
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/store/index.js
// module id = ./src/store/index.js
// module chunks = 34